/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 14:45:16
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-10 11:44:36
 * @Description: file content
 */
import qs from "qs";
import api from "@/api/henduoke-platform"
import myAxios from "./interceptors"
import Vue from 'vue/dist/vue.js'
let axios = new myAxios();
let _options = {};
// Add a request interceptor
axios.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("http interceptors by henduoke-platform");
  config.url = `${api.protocol}//${api.domain}`;

  if (config.params && (config.params.action || config.params.requestParam)) {
    let params = {
      j: JSON.stringify({
        openid: Vue.prototype.$openid || "",
        url: location.href,
        action: config.params.action,
        requestParam: config.params.requestParam || {}
      }),
      t: Math.ceil(Math.random() * 1000)
    };
    config.params = params;
  }

  // console.log("config", config);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// Add a response interceptor
axios.axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if (response.config.headers.res) {
    switch (response.config.headers.res) {
      case 'data':
        if (response.data) {
          response = response.data;
        }
        break;
      case 'data2':
        if (response.data && response.data.hasOwnProperty('data')) {
          response = response.data.data;
        } else {
          return Promise.reject(response);
        }
        break;
      default:
        break;
    }
  }
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});
export default {
  options: _options,
  qs: qs,
  get(url, param, addParam) {
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "get",
        url,
        params: param,
        headers: addParam
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  post(url, param, addParam) {
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "post",
        url,
        data: param,
        headers: addParam
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
